import * as service from './service'
import { HTTP_CODE } from '@/utils/request'

export default {
  namespace: 'honourExplain',
  state: {
    demoData: {}
  },
  effects: {
    * getHonourExplain ({ payload }, { call, put }) {
      const res = yield call(service.getHonourExplain, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
